module.exports = __webpack_public_path__ + "img/clariant-logo.b26a24bf.svg";